import {
  prepareFECampaignLimitFormatForBE,
  transformTranslations,
} from "components/Layout/Campaign/Common/campaignHelpers";
import { BEWalletTypeFormat, FEWalletTypeFormat } from "types/wallets";
import { SelectedLimitType } from "./LimitsSubSection";

export const formatWalletValues = (
  values: FEWalletTypeFormat,
  isEditMode?: boolean,
): BEWalletTypeFormat => {
  const {
    walletTypeId,
    createdAt,
    isDefault,
    otherValues,
    unitDaysActiveCount,
    unitYearsActiveCount,
    unitDaysExpiryAfter,
    unitDaysLocked,
    allTimeNotLocked,
    unitExpiryDate,
    ...rest
  } = values;
  const getUnitExpirationData = () => {
    switch (unitDaysExpiryAfter) {
      case "all_time_active":
      case "at_the_end_of_the_month":
        return { unitDaysExpiryAfter };
      case "after_x_days":
        return {
          unitDaysExpiryAfter,
          unitDaysActiveCount,
        };
      case "at_the_end_of_the_x_th_year":
        return {
          unitDaysExpiryAfter,
          unitYearsActiveCount,
        };
      case "at_the_end_of_the_chosen_date":
        return {
          unitDaysExpiryAfter,
          unitExpiryDate,
        };
    }
  };

  const unitExpirationSettings = getUnitExpirationData();
  const unitPendingSettings =
    allTimeNotLocked === "true"
      ? {
          allTimeNotLocked: true,
        }
      : {
          allTimeNotLocked: false,
          unitDaysLocked,
        };

  return {
    ...rest,
    code: isEditMode ? undefined : values.code,
    translations: transformTranslations(values.translations),
    limits: {
      points: prepareFECampaignLimitFormatForBE(
        values.limits?.points,
      ) as SelectedLimitType,
      pointsPerMember: prepareFECampaignLimitFormatForBE(
        values.limits?.pointsPerMember,
      ) as SelectedLimitType,
    },
    ...unitPendingSettings,
    ...unitExpirationSettings,
  };
};
